import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { type TranscriptionObject } from "services/suno-comms/types/transcription-object.type";
import Highlighted from "./highlighted.component";

type TranscriptionProps = {
  transcription: string;
  transcriptionObject?: TranscriptionObject;
  currentIndex: number;
};

export default function Transcription({
  transcription,
  transcriptionObject,
  currentIndex,
}: TranscriptionProps) {
  const [viewportHeight, setViewportHeight] = useState<number>(
    window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const divRef = useRef<HTMLDivElement>(null);

  const height =
    viewportHeight - (divRef.current?.getBoundingClientRect()?.top ?? 435) - 80;

  const content = useMemo(
    () =>
      transcription.split("\n\n").map((line, index) => (
        <React.Fragment key={index}>
          <Typography fontSize="16px" lineHeight={1.4}>
            {line}
          </Typography>
          <br />
        </React.Fragment>
      )),
    [transcription]
  );

  return (
    <Stack ref={divRef} width="100%" sx={{ boxSizing: "border-box", mt: 3 }}>
      <Typography component="div" sx={{ color: "grey", ml: 3, mb: 1 }}>
        Transcription:
      </Typography>

      <Box
        pl={3}
        pr={1}
        pt={1}
        pb={5}
        sx={{
          overflowY: "auto",
          height,
        }}
      >
        {transcriptionObject
          ? transcriptionObject?.segments.map((segment, index) => (
              <Highlighted key={index} highlighted={index === currentIndex}>
                {segment.text}
              </Highlighted>
            ))
          : content}
      </Box>
    </Stack>
  );
}
